module.exports = "../../static/img/fr.c1cf187.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/flags/fr.png
// module id = 926
// module chunks = 2